import {PagesWithoutFooter} from "../Constants/PagesWithoutFooter";

export function ShouldHideFooter(path: string) {
    return PagesWithoutFooter.includes(path.toLowerCase());
}
